<template lang="pug">
link-icon(:class="themeClass" :style="{ width, height}" )
</template>

<script>
import LinkIcon from '../../assets/common/link.vue';

export default {
  name: 'aiqLinkIcon',
  components: {
    LinkIcon,
  },
  props: {
    theme: {
      type: String,
      default: 'blue',
    },
    dark: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '20px',
    },
    height: {
      type: String,
      default: '20px',
    },
  },
  computed: {
    themeClass() {
      return {
        [`theme-${this.theme}-${this.dark ? 'dark' : 'light'}`]: true,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
// Use this approach to change svg color
// brightness(0%) saturate(100%) are added to clean up existing color set in svg
// https://stackoverflow.com/questions/22252472/how-to-change-the-color-of-an-svg-element
// stroke: #89aaea
.theme-blue-light {
  filter: brightness(0%) saturate(100%) invert(69%) sepia(7%)
          saturate(3849%) hue-rotate(189deg) brightness(101%) contrast(84%);
}

.theme-blue-dark {
  filter: brightness(0%) saturate(100%) invert(46%) sepia(94%)
          saturate(226%) hue-rotate(181deg) brightness(99%) contrast(97%);
}

// stroke: #FFFFFF
.theme-white-light {
  filter: brightness(0%) saturate(100%) invert(91%) sepia(98%)
          saturate(0%) hue-rotate(343deg) brightness(105%) contrast(102%);
}

// stroke: #808080
.theme-white-dark {
  filter: brightness(0%) saturate(100%) invert(70%) sepia(0%)
          saturate(4859%) hue-rotate(327deg) brightness(72%) contrast(87%);
}
</style>
